import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Plus } from "lucide-react";
import { toast } from "react-hot-toast";
import { getPackages } from "../../redux/slices/carWashSlice";
import { RootState } from "../../redux/store";
import { WashPanelItem } from "../../components/admin/WashPanel/WashPanelItem";
import { WashDetailsOverlay } from "../../components/admin/WashPanel/WashDetailsOverlay";
import { CarWashPackage } from "../../types/carWash.types";
import { AddWashOverlay } from "../../components/admin/WashPanel/AddWashOverlay";

const MAX_WASHES = 20;

export const WashesPanel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { packages } = useSelector((state: RootState) => state.wash);

  const [selectedWashID, setSelectedWashID] = useState<string>("");
  const [showAddWashOverlay, setShowAddWashOverlay] = useState<boolean>(false);

  useEffect(() => {
    if (!packages?.length) {
      dispatch(getPackages() as any);
    }
  }, [dispatch, packages?.length]);

  const handleAddWashClick = () => {
    if (packages.length >= MAX_WASHES) {
      toast.error(
        t("You can only add up to 20 wash packages. Remove an existing one.")
      );
      return;
    }

    setShowAddWashOverlay(true);
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">{t("Washes")}</h1>

        <button
          onClick={handleAddWashClick}
          title={t("Add Wash")}
          className="h-10 w-10 flex items-center justify-center rounded-lg shadow
            bg-popupLight dark:bg-popupDark
            hover:bg-gray-200 dark:hover:bg-gray-700 transition"
        >
          <Plus size={18} />
        </button>
      </div>

      {packages?.length > 0 && (
        <div className="mt-6 space-y-3">
          {packages.map((pkg) => (
            <WashPanelItem
              key={pkg._id}
              pkg={pkg}
              setSelectedWashID={setSelectedWashID}
            />
          ))}
        </div>
      )}

      {packages?.length === 0 && (
        <div className="mt-10 text-center text-gray-500 dark:text-gray-400">
          {t("No wash packages found")}
        </div>
      )}

      {selectedWashID && (
        <WashDetailsOverlay
          wash={
            packages.find((pkg) => pkg._id === selectedWashID) as CarWashPackage
          }
          onClose={() => setSelectedWashID("")}
        />
      )}

      {showAddWashOverlay && (
        <AddWashOverlay onClose={() => setShowAddWashOverlay(false)} />
      )}
    </div>
  );
};
